module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ce-Db-Ed.cfb276e7.png";